import {
  Edit,
  NumberInput,
  RecordField,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "@/components/admin"
import { RaRecord, useGetIdentity } from "ra-core"
import { ReactElement } from "react"
import StoreyCard from "../../components/storey-card"

const StoreysEdit = (): ReactElement => {
  const { data: identity } = useGetIdentity()

  return (
    <Edit
      className="py-6"
      title={null}
      transform={(data: RaRecord) => ({
        ...data,
        updated_at: new Date().toISOString(),
        updated_by: identity?.id,
      })}
      redirect={(resource, id, data: any) => {
        console.log(resource, id)
        return `/projects/${data.project_id}/edit`
      }}
    >
      <SimpleForm>
        <br />

        <StoreyCard
          open
          title="Modifier l'étage"
          level={<RecordField source="level" label="" />}
          rooms={<RecordField source="rooms" label="" />}
          bathrooms={<RecordField source="bathrooms" label="" />}
          wcs={<RecordField source="wcs" label="" />}
        >
          <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-6 xs:grid-cols-6 gap-4 pb-4">
            <TextInput source="title" />
            <TextInput source="description" />
            <NumberInput source="level" />
            <NumberInput source="surface" />
            <NumberInput source="rooms" />
            <NumberInput source="bathrooms" />
            <NumberInput source="wcs" />
            <ReferenceInput reference="project_phases" source="status">
              <SelectInput />
            </ReferenceInput>
          </div>
        </StoreyCard>
      </SimpleForm>
    </Edit>
  )
}

export default StoreysEdit
